import React from 'react';
import '../Estilos/PesquisaInput.css';

import searchIcon from '../Icones/lupa_pesquisa.svg';

export default function PesquisaInput({ placeholder, onSearch }) {
  return (
    <div className="ContainerPesquisa">
      <div className="ContainerInputPesquisa">
        <div className="InputLupaView">
          <input
            type="text"
            placeholder={placeholder}
            onChange={(e) => onSearch(e.target.value)}
          />
          <img src={searchIcon} alt="Search" />
        </div>
      </div>
    </div>
  );
}
